/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const TimerIcon = ({className}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
    >
      <path
        d="M10.96 1.90405C6.13511 1.90405 2.20978 5.82948 2.20978 10.6544C2.20978 15.4793 6.13511 19.4048 10.96 19.4048C15.785 19.4048 19.7104 15.4794 19.7104 10.6544C19.7104 5.82948 15.7851 1.90405 10.96 1.90405ZM10.96 17.5732C7.14497 17.5732 4.04122 14.4694 4.04122 10.6543C4.04122 6.83924 7.14506 3.7354 10.96 3.7354C14.7751 3.7354 17.879 6.83924 17.879 10.6543C17.879 14.4694 14.7752 17.5732 10.96 17.5732Z"
        fill="#7E92A2"
      />
      <path
        d="M5.12597 2.26989C5.545 1.98674 5.65525 1.41753 5.37211 0.998498C5.08897 0.579372 4.51985 0.469028 4.10072 0.752352C2.30646 1.96449 0.913556 3.6561 0.072558 5.64423C-0.124414 6.11005 0.0934365 6.6474 0.559172 6.84437C0.675652 6.89364 0.796527 6.9169 0.915571 6.9169C1.27234 6.9169 1.61161 6.70701 1.75932 6.35776C2.46186 4.69673 3.62611 3.28313 5.12597 2.26989Z"
        fill="#7E92A2"
      />
      <path
        d="M21.9275 5.64415C21.0864 3.65593 19.6935 1.96432 17.8993 0.752272C17.4803 0.469131 16.9109 0.579292 16.6279 0.998417C16.3447 1.41745 16.455 1.98666 16.874 2.2698C18.3739 3.28305 19.5381 4.69665 20.2408 6.35768C20.3886 6.70702 20.7277 6.91682 21.0846 6.91682C21.2036 6.91682 21.3244 6.89346 21.4409 6.84429C21.9067 6.64723 22.1245 6.10988 21.9275 5.64415Z"
        fill="#7E92A2"
      />
      <path
        d="M13.7296 7.37146C13.372 7.01387 12.7923 7.01387 12.4345 7.37146L9.8634 9.94253C9.84427 9.96167 9.82659 9.98182 9.80947 10.0022C9.78914 10.0194 9.76899 10.0369 9.74985 10.0561C9.39227 10.4137 9.39217 10.9935 9.74985 11.3512L12.4345 14.0359C12.6133 14.2146 12.8476 14.3041 13.082 14.3041C13.3163 14.3041 13.5506 14.2146 13.7295 14.0359C14.0871 13.6783 14.0871 13.0985 13.7295 12.7408L11.6924 10.7036L13.7295 8.66648C14.0872 8.30889 14.0872 7.72905 13.7296 7.37146Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
